import { cn } from "@screener/uikit/lib/utils";
import type { ChipParts } from "@/lib/labels";

/**
 * Общий вид кнопок-фишек полосы фильтров («Мин. объём», «Показ»; размер
 * `tag` у `Button`): заданная — secondary с приглушённой подписью, незаданная —
 * пунктир, недоступная — предупреждающая. Фишки отбора — `Tag` UIKit.
 * Экранный код, не UIKit: фишки знают про отбор плотностей.
 */

export type ChipTone = "set" | "unset" | "warning";

/** Классы фишки по тону; вариант (`secondary`/`outline`) выбирает `chipVariant`. */
export function chipToneClass(tone: ChipTone): string {
  return cn(
    "tabular-nums",
    tone === "unset" && "border-dashed border-input bg-transparent text-muted-foreground",
    tone === "warning" && "border-warning text-warning",
  );
}

export function chipVariant(tone: ChipTone): "secondary" | "outline" {
  return tone === "set" ? "secondary" : "outline";
}

/**
 * Содержимое фишки: подпись приглушена, значение основным цветом. Пробел-текст
 * между ними нужен доступному имени; во flex он не виден.
 */
export function ChipContent({ label, value }: ChipParts) {
  if (value === undefined) {
    return <>{label}</>;
  }
  return (
    <>
      <span className="text-muted-foreground">{label}</span> <span>{value}</span>
    </>
  );
}
